/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { Component, Input } from '@angular/core';
import { DateComponent } from '../../date/date.component';
import { IconComponent } from '../../icon/icon.component';

registerLocaleData(localeDe);

@Component({
  selector: 'ods-cross-status',
  imports: [IconComponent, DateComponent],
  host: { class: 'flex gap-1 w-fit' },
  template: `<ods-icon name="close" [config]="{ fill: 'traffic-light-red' }" />
    <div>
      <p class="text-text">{{ text }}</p>
      <ods-date [date]="date" />
    </div>`,
})
export class CrossStatusComponent {
  @Input() text: string;
  @Input() date: Date;
}
